import type { EngineUseCase } from '../../engines/models/engine';
import { unpaginatedListResponse } from '../../utils/listResponse';
import { preTrainedFieldSchema } from '../models/preTrainedField.schema';
import { listPreTrainedFieldsQuerySchema } from './listPreTrainedFields.schema';

export type ListPreTrainedFieldsQuery = {
  engineUseCase?: EngineUseCase;
};

export const listPreTrainedFields = (query: ListPreTrainedFieldsQuery = {}) => {
  return {
    endpoint: `/engine_fields/pre_trained_fields`,
    method: 'GET',
    responseSchema: unpaginatedListResponse(preTrainedFieldSchema),
    query,
    querySchema: listPreTrainedFieldsQuerySchema,
  } as const;
};
